import Image from 'next/image';
import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable } from '@/design-system/components/ui';

import { HypurrCardOperationType, Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function HypurrCardTransactionsTriggerFullDetails({ trigger }: Props) {
  const operationTypeLabel = useMemo(() => {
    const operationType = trigger.context?.operationType;
    return operationType === HypurrCardOperationType.Borrow
      ? 'Borrow'
      : operationType === HypurrCardOperationType.Withdraw
        ? 'Withdraw'
        : '-';
  }, [trigger.context]);

  const networkDisplay = useMemo(() => {
    return (
      <div className="tw:flex tw:flex-row tw:items-center tw:gap-2">
        <Image src="/assets/svg/hyperevm.svg" alt="HyperEVM" width={20} height={20} />
        <span>HyperEVM</span>
      </div>
    );
  }, []);

  const operationTypeDisplay = useMemo(() => {
    if (operationTypeLabel === '-') return '-';

    const variant = operationTypeLabel === 'Borrow' ? 'warning' : 'default';

    return <Badge variant={variant}>{operationTypeLabel}</Badge>;
  }, [operationTypeLabel]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Network" value={networkDisplay} />
      <KeyValueRow label="Operation Type" value={operationTypeDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
